<p-inputgroup class="align-items-center">
    @if (hasLabel) {
        <label class="pr-2" [for]="inputElementId"
               [style.width]="labelWidth">{{ label }}</label>
    }
    <div [style.width]="inputWidth" class="inline-block">
        <p-icon-field>
            <p-date-picker
                [inputId]="inputElementId" [ngModel]="timedDate"
                (ngModelChange)="onChange($event)" [showTime]="showTime"
                dateFormat="dd/mm/yy" appendTo="body" [disabled]="disabled"
                [readonlyInput]="readOnly"
                [panelStyleClass]="readOnly ? 'hidden' : ''"
                hourFormat="24" timeSeparator=":"
            ></p-date-picker>
        </p-icon-field>
    </div>
</p-inputgroup>
